import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Box from '@material-ui/core/Box';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
}));

export default function FaqItem(props) {
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => (event, isExpanded) => {
    setExpanded(isExpanded ? true : false);
  };
  const classes = useStyles();

  return (
    <Accordion
      className={classes.root}
      expanded={props.isSearched || expanded}
      onChange={handleChange()}
      {...props}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box>
          <Typography variant="h5" style={{ fontSize: 16 }}>
            <div
              dangerouslySetInnerHTML={{
                __html: props.title,
              }}
            />
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box px={'20px'} py={'12px'}>
          {props.content.map((paragraph, ix) => {
            return (
              <Typography
                variant="body1"
                style={{ fontSize: 16, marginTop: 14, marginBottom: 14 }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: paragraph,
                  }}
                />
              </Typography>
            );
          })}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
